import { render, staticRenderFns } from "./IntCard.vue?vue&type=template&id=465b609e&scoped=true&lang=pug"
import script from "./IntCard.vue?vue&type=script&lang=js"
export * from "./IntCard.vue?vue&type=script&lang=js"
import style0 from "./IntCard.vue?vue&type=style&index=0&id=465b609e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465b609e",
  null
  
)

export default component.exports